import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(176px, 1fr));
  gap: 40px 24px;

  @media (max-width: 520px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 28px 14px;
  }
`;

export const Divider = styled.div`
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  gap: 18px;
  scroll-margin-top: 96px;
  animation: fadeIn 0.4s;

  &:not(:first-child) {
    margin-top: 16px;
  }

  .letter {
    font-family: var(--font-display);
    font-style: italic;
    font-weight: 800;
    font-size: 64px;
    line-height: 1;
    letter-spacing: -0.04em;
    color: var(--accent);
  }

  .rule {
    flex: 1;
    height: 1px;
    background: var(--line);
  }

  .count {
    font-family: var(--font-mono);
    font-size: 12px;
    color: var(--muted);
  }
`;
